// extracted by mini-css-extract-plugin
export default {"wrapper":"latest-requests_wrapper__h-k7Z","header":"latest-requests_header__eNmB6","title":"latest-requests_title__+Hqzg"};